module.exports = __webpack_public_path__ + "static/media/icon_button2_b.0d6ccef3.svg";